import { useState } from "react";
import authProvider from "../authProvider";
import logo from '../assets/logo.svg'
import { Link } from "react-router-dom";
import SpinnerButton from "../components/SpinnerButton.jsx";

export default function Login({ onSuccess } = {}) {
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (event) => {
    setLoading(true);
    setError(null);
    event.preventDefault()
    const formData = new FormData(event.currentTarget);
    const formJson = Object.fromEntries((formData).entries());
    const { error } = await authProvider.login({ email: formJson.email, password: formJson.password });
    if (error) {
      if (error?.name === "SessionExpired") {
        setError("Your session expired. Please log in again.")
      } else if (error?.name === "AuthApiError") {
        setError("Invalid email or password.")
      } else {
        setError("Unknown login error.")
      }
      setLoading(false);
    } else if (onSuccess) {
      const identity = await authProvider.getIdentity();
      onSuccess(identity);
    }
  }

  return (
    <>
      <div className="flex min-h-full flex-1 flex-col justify-center py-12 sm:px-6 lg:px-8">
        <div className="sm:mx-auto sm:w-full sm:max-w-md">
          <img
            alt="Fungistics Logo"
            src={logo}
            className="mx-auto h-10 w-auto"
          />
          <h2 className="mt-6 text-center text-2xl/9 font-bold tracking-tight text-gray-900">
            Sign in to Fungistics
          </h2>
        </div>

        <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-[480px]">
          <div className="bg-white px-6 py-12 shadow sm:rounded-lg sm:px-12">
            <form onSubmit={handleSubmit} className="space-y-6">
              <div>
                <label htmlFor="email" className="block text-sm/6 font-medium text-gray-900">
                  Email address
                </label>
                <div className="mt-2">
                  <input
                    id="email"
                    name="email"
                    type="email"
                    required
                    autoComplete="email"
                    className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-cyan-800 sm:text-sm/6"
                  />
                </div>
              </div>

              <div>
                <label htmlFor="password" className="block text-sm/6 font-medium text-gray-900">
                  Password
                </label>
                <div className="mt-2">
                  <input
                    id="password"
                    name="password"
                    type="password"
                    required
                    autoComplete="current-password"
                    className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-cyan-800 sm:text-sm/6"
                  />
                </div>
              </div>

              {error &&
                <div className="flex items-center justify-between text-red-500">
                  {error}
                </div>
              }
              <div className="flex items-center justify-between">
                <div className="flex gap-3">
                  <div className="flex h-6 shrink-0 items-center">
                    <div className="group grid size-4 grid-cols-1">
                      <input
                        id="remember-me"
                        name="remember-me"
                        type="checkbox"
                        className="col-start-1 row-start-1 appearance-none rounded border border-gray-300 bg-white checked:border-cyan-800 checked:bg-cyan-800 indeterminate:border-cyan-800 indeterminate:bg-cyan-800 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-cyan-800 disabled:border-gray-300 disabled:bg-gray-100 disabled:checked:bg-gray-100 forced-colors:appearance-auto"
                      />
                      <svg
                        fill="none"
                        viewBox="0 0 14 14"
                        className="pointer-events-none col-start-1 row-start-1 size-3.5 self-center justify-self-center stroke-white group-has-[:disabled]:stroke-gray-950/25"
                      >
                        <path
                          d="M3 8L6 11L11 3.5"
                          strokeWidth={2}
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="opacity-0 group-has-[:checked]:opacity-100"
                        />
                        <path
                          d="M3 7H11"
                          strokeWidth={2}
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="opacity-0 group-has-[:indeterminate]:opacity-100"
                        />
                      </svg>
                    </div>
                  </div>
                  <label htmlFor="remember-me" className="block text-sm/6 text-gray-900">
                    Remember me
                  </label>
                </div>

                <div className="text-sm/6">
                  <Link to="/forgot-password" className="font-semibold text-cyan-800 hover:text-cyan-600">
                    Forgot password?
                  </Link>
                </div>
              </div>

              <div>
                <button
                  type="submit"
                  disabled={loading}
                  className={`flex w-full justify-center items-center rounded-md px-3 py-1.5 text-sm/6 font-semibold shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 ${loading
                    ? "bg-cyan-600 text-gray-200 cursor-not-allowed"
                    : "bg-cyan-800 text-white hover:bg-cyan-600 focus-visible:outline-cyan-800"
                    }`}
                >
                  {loading ? (
                    <SpinnerButton />
                  ) : (
                    "Sign in"
                  )}
                </button>
              </div>
            </form>

          </div>

          <p className="mt-10 text-center text-sm/6 text-gray-500">
            No account?{' '}
            <Link to="/register" className="font-semibold text-cyan-800 hover:text-cyan-600">
              Sign up for free.
            </Link>
          </p>
        </div>
      </div>
    </>
  )
}

